import { render, staticRenderFns } from "./ResetWizardModal.vue?vue&type=template&id=0bd57541&"
import script from "./ResetWizardModal.vue?vue&type=script&lang=ts&"
export * from "./ResetWizardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports